module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Change password"},"de":{"title":"Passwort ändern"},"fr":{"title":"Modifier le mot de passe"},"it":{"title":"Modificare Password"}}')
  delete Component.options._Ctor
}
